export const STATUS_OPTIONS = [
  'Draft',
  'Posted',
  'Open',
  'Partially Settled',
  'Settled',
];

export function formatReturnDate(value) {
  const ms = Number(value);
  if (!Number.isFinite(ms) || ms <= 0) return '';
  const date = new Date(ms);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatMoney(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '0.00';
  return amount.toFixed(2);
}

export function formatCredit(value) {
  if (value === null || value === undefined || value === '') return '';
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return '';
  return amount.toFixed(2);
}

export function startOfDayMs(dateStr) {
  const [year, month, day] = String(dateStr).split('-').map(Number);
  return new Date(year, month - 1, day, 0, 0, 0, 0).getTime();
}

export function endOfDayMs(dateStr) {
  const [year, month, day] = String(dateStr).split('-').map(Number);
  return new Date(year, month - 1, day, 23, 59, 59, 999).getTime();
}

export function statusClassName(styles, status) {
  if (status === 'Draft') return `${styles.pill} ${styles.pillDraft}`;
  if (status === 'Posted') return `${styles.pill} ${styles.pillPosted}`;
  if (status === 'Open' || status === 'Partially Settled') {
    return `${styles.pill} ${styles.pillOpen}`;
  }
  if (status === 'Settled') return `${styles.pill} ${styles.pillSettled}`;
  return styles.pill;
}
